/**
 * One hash, shared by everything in the showcase that draws from a seed.
 *
 * The drawn avatars, storefronts and video stills all pick their features from
 * a handle or a name, and the first version summed code points weighted by
 * position. That is fine as a hash and useless as a spread: `@northloopgear`
 * and `@maren.builds` landed on the same room, the same hair and the same skin,
 * so two of the three video covers were the same picture.
 *
 * FNV-1a, and each feature reads a different slice of the result, so two seeds
 * that collide on one feature do not collide on the rest.
 */
const OFFSET = 2166136261;
const PRIME = 16777619;

export const seedHash = (seed: string): number => {
  let hash = OFFSET;
  for (let index = 0; index < seed.length; index++) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, PRIME);
  }
  return hash >>> 0;
};

/** One feature off the hash. `slot` picks which bits to read, so features drawn
 *  from the same seed vary independently. */
export const seedPick = (hash: number, slot: number, count: number): number =>
  Math.floor(hash / 2 ** (slot * 5)) % count;
